<template>
  <div class="emb-cart-wrap emb-card">
    <emb-page-title
      :heading=" bannerSection.Heading"
      :subHeading="bannerSection.Subheading"
      :image="bannerSection.Image_1920x700px"
    ></emb-page-title>
    <div class="cart-content section-gap">
      <v-container grid-list-xl py-0>
        <div v-if="cart == ''" class="text-center">
          <div class="text-center">
            <div class="mb-6">
              <img alt="cart-empty" height="128" :src="empSection.image_128x128px" width="128" />
            </div>
            <h4>{{empSection.Heading}}</h4>
            <router-link class="primary--text" to="/">{{empSection.Subtitle1}}</router-link>
          </div>
        </div>
        <div v-else class="cart-shop-list">
          <div class="emb-card mb-12 pa-6 white">
            <div v-for="(item, index) in cart" :key="index">
              <v-row class="cart-item-wrap">
                <v-col cols="12" sm="12" md="2" class="d-inline-flex align-center justify-center">
                  <router-link :to="detailPage(item.More_details_page_link)">
                    <img :src="item.Product_Image_626_x_800px" alt="cart-item" width="100" />
                  </router-link>
                </v-col>
                <v-col cols="12" sm="6" md="4" class="d-inline-flex align-center justify-center">
                  <div class="text-center">
                    <router-link :to="detailPage(item.More_details_page_link)">
                      <h5 class="mb-1">{{item.Name}}</h5>
                    </router-link>
                    <!-- <p class="mb-0">Delivery in 3-4 days | Free</p>
                    <p class="mb-0">10 Days Replacement Policy</p>-->
                  </div>
                </v-col>
                <v-col cols="6" sm="3" md="2" class="d-inline-flex align-center justify-center">
                  <v-text-field
                    class="d-inline-block"
                    type="number"
                    v-model="item.quantitySelected"
                    min="1"
                    max="10"
                    placeholder="Quantity"
                    onkeydown="return false"
                  ></v-text-field>
                  <!-- <InputNumber
                    v-model="item.quantitySelected"
                    buttonLayout="horizontal"
                    spinnerMode="horizontal"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                    showButtons
                    :min="1"
                    readonly="true"
                    size="1"
                  />-->
                  <!-- <v-text-field v-model="item.quantitySelected" type="number" label="Number" append-outer-icon="add" 
                  @click:append-outer="increment" prepend-icon="remove" @click:prepend="decrement"></v-text-field>-->
                </v-col>
                <v-col cols="6" sm="3" md="2" class="d-inline-flex align-center justify-center">
                  <h4 class="mb-0">
                    <!-- <emb-currency-sign></emb-currency-sign> -->
                    {{ $n(unitPrice(item.quantitySelected,item.sellingPrice) / selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency) }}
                  </h4>
                </v-col>
                <v-col
                  cols="2"
                  sm="2"
                  md="2"
                  class="res-float-icon d-inline-flex align-center justify-md-center justify-end"
                >
                  <a
                    class="accent--text remove-cart"
                    @click="deleteProductFromCart(item)"
                    href="javascript:void(0)"
                  >
                    <i class="material-icons font-weight-bold">close</i>
                  </a>
                </v-col>
              </v-row>
            </div>
          </div>
          <v-layout align-center justify-end>
            <vue-snotify></vue-snotify>
            <v-flex xs12 sm12 md5 lg5 xl5 py-0>
              <div class="layout align-center justify-space-between subtotal">
                <p>{{cartSection.Subtotal_Label}}</p>
                <span>{{ $n((itemTotal/selectCurrency.CurrencyMultiplier),'currency',selectCurrency.selectedCurrency) }}</span>
              </div>
              <div class="layout align-center justify-space-between subtotal">
                <p>{{cartSection.Shipping_Label }}</p>
                <span>{{ $n((shippingCharge/selectCurrency.CurrencyMultiplier),'currency',selectCurrency.selectedCurrency) }}</span>
              </div>

              <!-- Tax -->
              <!-- <div class="layout align-center justify-space-between subtotal">
                <p>{{cartSection.Tax_Label}}</p>
                <span>
                  <emb-currency-sign></emb-currency-sign>
                  {{$n((tax / selectedCurrency.currencyRate))}}
                </span>
              </div>-->

              <v-divider class="my-3"></v-divider>

              <div class="layout align-center justify-space-between subtotal layout-gap">
                <h4>{{cartSection.Total_Label}}</h4>
                <h4>
                  <!-- <emb-currency-sign></emb-currency-sign> -->
                  {{ $n((itemTotal+shippingCharge)/selectCurrency.CurrencyMultiplier,'currency',selectCurrency.selectedCurrency) }}
                </h4>
              </div>

              <v-divider class="my-3"></v-divider>

              <div class="layout justify-end subtotal">
                <v-btn
                  large
                  class="accent mr-0"
                  @click="makeOrder()"
                >{{cartSection.Checkout_Button_Label}}</v-btn>
              </div>
            </v-flex>
          </v-layout>
          <!-- <emb-delete-confirmation
            ref="deleteConfirmationDialog"
            message="Are you sure you want to delete this product?"
            @onConfirm="onDeleteProductFromCart"
          ></emb-delete-confirmation>-->
        </div>
      </v-container>
    </div>
  </div>
</template>
<script>
// import "primevue/resources/themes/mdc-light-indigo/theme.css";
// import "primevue/resources/primevue.min.css"; //core css
// import "primeicons/primeicons.css";

// import InputNumber from "primevue/inputnumber";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../services/utils/cms-helper";
export default {
  components: {
    // InputNumber,
  },
  data() {
    return {
      bannerSection: "",
      cartSection: "",
      empSection: "",
      deliveryInfo: {
        Threshold_Price: "",
        Threshold_Price_Above: "",
        Threshold_Price_Below: "",
      },
      hasShippingAddress: false,
      selectedCurrency: localStorage.selectedCurrency
        ? localStorage.selectedCurrency
        : "AED",
      CurrencyMultiplier: localStorage.CurrencyMultiplier
        ? parseFloat(localStorage.CurrencyMultiplier)
        : parseFloat(1),
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.readShippingAddress();
    this.getPageData1();
    this.getPageData2();
  },
  watch: {
    selectedLocale() {
      this.getPageData1();
      this.getPageData2();
    },
  },
  computed: {
    ...mapGetters(["cart", "selectCurrency", "selectedLocale"]),
    itemTotal() {
      return this.cart.reduce((total, product) => {
        return total + product.sellingPrice * product.quantitySelected;
      }, 0);
    },
    shippingCharge() {
      if (
        this.deliveryInfo.Threshold_Price != null &&
        this.deliveryInfo.Threshold_Price != ""
      ) {
        if (this.deliveryInfo.Threshold_Price < this.itemTotal) {
          return this.deliveryInfo.Threshold_Price_Above
            ? Number(this.deliveryInfo.Threshold_Price_Above)
            : 0;
        } else {
          return this.deliveryInfo.Threshold_Price_Below
            ? Number(this.deliveryInfo.Threshold_Price_Below)
            : 0;
        }
      } else {
        return 0;
      }
    },
  },
  methods: {
    unitPrice(price, qty) {
      return Number(price) * Number(qty);
    },
    deleteProductFromCart(product) {
      // this.$refs.deleteConfirmationDialog.openDialog();
      // this.selectDeletedProduct = product;
      // this.$refs.deleteConfirmationDialog.close();
      this.$snotify.error(
        this.cmsRequestFunctions.getValidationMsgByCode("M024"),
        {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
        }
      );
      this.$store.dispatch("onDeleteProductFromCart", product);
    },
    getPageData1: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "29 Cart/29 Cart/29 Cart.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;

          if (res.area_List) {
            var cartArea = self.cmsRequestFunctions.pluck(
              "Cart_Section",
              res.area_List
            );
            self.cartSection = self.cmsRequestFunctions.getAllMapData(
              cartArea[0].component
            );
            var bannerArea = self.cmsRequestFunctions.pluck(
              "Banner_Section",
              res.area_List
            );
            self.bannerSection = self.cmsRequestFunctions.getAllMapData(
              bannerArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    getPageData2: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "25 Check Out/25 Check Out/25 Check Out.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;

          if (res.area_List) {
            var emptyBag = self.cmsRequestFunctions.pluck(
              "Check_Out_Section",
              res.area_List
            );
            self.empSection = self.cmsRequestFunctions.getAllMapData(
              emptyBag[0].component
            );

            var deliveryInfo = self.cmsRequestFunctions.pluck(
              "Delivery_Info_Section",
              res.area_List
            );
            self.deliveryInfo = self.cmsRequestFunctions.getAllMapData(
              deliveryInfo[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    readShippingAddress: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      if (user != null && user != undefined) {
        self.userData = JSON.parse(user);
        self.loginDetails = self.userData.user_data;
        var userName = self.loginDetails.loginId;
        self.email = self.loginDetails.email;
        var filterValue =
          "type='Shipping Address' AND keyword12='" + userName + "'";
        var allData = await self.cmsRequestFunctions.getDbDataTableValue(
          filterValue,
          "date1"
        );
        if (
          allData != undefined &&
          allData.data != undefined &&
          allData.status == 200
        ) {
          var shippingAddress = allData.data.data;
          if (shippingAddress) {
            self.hasShippingAddress = shippingAddress.length
              ? true
              : false || false;
          }
        } else {
          console.log("error:", allData);
        }
      }
    },
    makeOrder() {
      this.$store.dispatch("makeOrder", this.hasShippingAddress);
    },
    detailPage(url) {
      if (url != "") {
        url = url.split("/Template/")[1];
        // url = url.split(" ").join("-");
        url = url.split(".").slice(0, -1).join(".");
        url = "/product-details?page=" + url;
      } else {
        url = "#";
      }
      return url;
    },
  },
};
</script>

